import cssUtil from 'gw-portals-util-js/CssUtil';
import styles from './quoteViewCell-hashed.scss';
import templateStr from 'text!./quoteViewCell.html';

function controller() {
    const $ctrl = this;
    $ctrl.termValue_PSA = (term) => {
        let value;
            if (term.hasOptions) {
                value = term.options.find((option) => option.code === term.value).name;
            } else {
                value = term.value;
            }
        return value;
    };
}

export default {
    restrict: 'E',
    bindings: {
        cellData: '<',
        coverageTypeId: '<',
        coverageGroupId: '<',
        coverageId: '<'
    },
    template: cssUtil.hashTemplate(templateStr, styles),
    controller: controller // PSA
};